import './App.css';

import SearchMain from './components/SearchMain';
import './components/style.css';

function App() {
  return (
    <div>
      <SearchMain />
    </div>
  );
}

export default App;
